function generateDynamicRoutes() {
  return [
    {
      path: "/home/index",
      name: "home",
      component: "/home/index",
      meta: {
        title: "Home",
        isLink: "",
        isHide: false,
        isFull: false,
        isAffix: true,
        isKeepAlive: true
      },
      children: [
        {
          path: "/container/overview",
          name: "ContainerOverview",
          component: "/containerOverview/index",
          meta: {
            title: "ContainerOverview",
            isLink: "",
            isHide: true,
            isFull: false,
            isAffix: true,
            isKeepAlive: true
          },
          children: [
            {
              path: "/container/tenantCreate",
              name: "tenantCreate",
              component: "/tenantCreate/index",
              meta: {
                title: "create Tenant",
                isLink: "",
                isHide: true,
                isFull: false,
                isAffix: true,
                isKeepAlive: true
              }
            },
            {
              path: "/management/Container",
              name: "managementContainer",
              component: "/managementContainer/index",
              meta: {
                title: "Management device",
                isHide: true,
                isFull: false,
                isAffix: false,
                isKeepAlive: true
              }
            },
            {
              path: "/tenant/overview",
              name: "tenantOverview",
              component: "/tenantOverview/index",
              meta: {
                title: "Tenant Overview",
                isLink: "",
                isHide: true,
                isFull: false,
                isAffix: true,
                isKeepAlive: true
              },
              children: [
                {
                  path: "/assignDevicesTenant/index",
                  name: "assignDevicesTenant",
                  component: "/assignDevicesTenant/index",
                  meta: {
                    title: "Tenant Assign devices",
                    isHide: true,
                    isFull: false,
                    isAffix: false,
                    isKeepAlive: true
                  }
                },
                {
                  path: "/tenant/data",
                  name: "TenantData",
                  component: "/groupDataTenant/index",
                  meta: {
                    title: "TenantData",
                    isLink: "",
                    isHide: true,
                    isFull: false,
                    isAffix: true,
                    isKeepAlive: true
                  },
                  children: [
                    {
                      path: "/group/detail",
                      name: "groupDetail",
                      component: "/groupDetail/index",
                      meta: {
                        title: "groupDetail",
                        isLink: "",
                        isHide: true,
                        isFull: false,
                        isAffix: true,
                        isKeepAlive: true
                      }
                    },
                    {
                      path: "/group/configuration/index",
                      name: "groupConfiguration",
                      component: "/groupConfiguration/index",
                      meta: {
                        title: "groupConfiguration",
                        isLink: "",
                        isHide: true,
                        isFull: false,
                        isAffix: true,
                        isKeepAlive: true
                      }
                    }
                  ]
                },
                {
                  path: "/group/overview",
                  name: "groupOverview",
                  component: "/groupOverview/index",
                  meta: {
                    title: "Group Overview",
                    isLink: "",
                    isHide: true,
                    isFull: false,
                    isAffix: true,
                    isKeepAlive: true
                  },
                  children: [
                    {
                      path: "/assignDevicesGroup/index",
                      name: "assignDevicesGroup",
                      component: "/assignDevicesGroup/index",
                      meta: {
                        title: "Group Assign devices",
                        isHide: true,
                        isFull: false,
                        isAffix: false,
                        isKeepAlive: true
                      }
                    },
                    {
                      path: "/devicePage/index",
                      name: "devicePage",
                      component: "/devicePage/index",
                      meta: {
                        title: "devicePage",
                        isHide: false,
                        isFull: false,
                        isAffix: false,
                        isKeepAlive: true
                      }
                    },
                    {
                      path: "/group/data",
                      name: "groupData",
                      component: "/groupData/index",
                      meta: {
                        title: "groupData",
                        isLink: "",
                        isHide: true,
                        isFull: false,
                        isAffix: true,
                        isKeepAlive: true
                      },
                      children: [
                        {
                          path: "/group/detail",
                          name: "groupDetail",
                          component: "/groupDetail/index",
                          meta: {
                            title: "groupDetail",
                            isLink: "",
                            isHide: true,
                            isFull: false,
                            isAffix: true,
                            isKeepAlive: true
                          }
                        },
                        {
                          path: "/group/configuration/index",
                          name: "groupConfiguration",
                          component: "/groupConfiguration/index",
                          meta: {
                            title: "groupConfiguration",
                            isLink: "",
                            isHide: true,
                            isFull: false,
                            isAffix: true,
                            isKeepAlive: true
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  path: "/groupCreate/index",
                  name: "groupCreate",
                  component: "/groupCreate/index",
                  meta: {
                    title: "Create Group",
                    isLink: "",
                    isHide: true,
                    isFull: false,
                    isAffix: true,
                    isKeepAlive: true
                  }
                },
                {
                  path: "/groupEdit/index",
                  name: "groupEdit",
                  component: "/groupEdit/index",
                  meta: {
                    title: "groupEdit",
                    isLink: "",
                    isHide: true,
                    isFull: false,
                    isAffix: true,
                    isKeepAlive: true
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    // 之前为不同角色单独配置的 /group/index、/Tenant/index 首页路由已移除，
    // 所有角色统一使用上面的 /home/index 作为首页。

    {
      path: "/container/containerCreate",
      name: "containerCreate",
      component: "/containerCreate/index",
      meta: {
        title: "Create container",
        isLink: "",
        isHide: true,
        isFull: false,
        isAffix: true,
        isKeepAlive: true
      }
    },

    {
      path: "/monitoring",
      name: "monitoring",
      component: "/monitoring/index",
      meta: {
        title: "Monitoring",
        isLink: "",
        isHide: true,
        isFull: false,
        isAffix: true,
        isKeepAlive: true
      },
      children: [
        {
          path: "/monitoring/index",
          name: "monitoringOverview",
          component: "/monitoring/index",
          meta: {
            title: "Overview",
            isLink: "",
            isHide: false,
            isFull: false,
            isAffix: true,
            isKeepAlive: true
          }
        },
        {
          path: "/deviceMap/index",
          name: "deviceMap",
          component: "/deviceMap/index",
          meta: {
            title: "Map",
            isHide: true,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/deviceBattery/index",
          name: "deviceBattery",
          component: "/deviceBattery/index",
          meta: {
            title: "Battery",
            isHide: true,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },

        {
          path: "/monitoring/event",
          name: "event",
          component: "/monitoring/event",
          meta: {
            title: "Event",
            isHide: false,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/monitoring/alert",
          name: "alert",
          component: "/monitoring/alert",
          meta: {
            title: "Alert",
            isHide: false,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        }
      ]
    },
    {
      path: "/group",
      name: "group",
      component: "/group/index",
      meta: {
        title: "Group",
        isLink: "",
        isHide: true,
        isFull: false,
        isAffix: true,
        isKeepAlive: true
      }
    },
    {
      path: "/device",
      name: "device",
      component: "/managementOverview/index",
      meta: {
        title: "Device",
        isLink: "",
        isHide: false,
        isFull: false,
        isAffix: true,
        isKeepAlive: true
      },
      children: [
        {
          path: "/managementOverview/index",
          name: "managementOverview",
          component: "/managementOverview/index",
          meta: {
            title: "Management",
            isHide: false,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          },
          children: [
            {
              path: "/assignDevicesTenant/index",
              name: "assignDevicesTenant",
              component: "/assignDevicesTenant/index",
              meta: {
                title: "Tenant Assign devices",
                isHide: true,
                isFull: false,
                isAffix: false,
                isKeepAlive: true
              }
            },
            {
              path: "/assignDevicesGroup/index",
              name: "assignDevicesGroup",
              component: "/assignDevicesGroup/index",
              meta: {
                title: "Group Assign devices",
                isHide: true,
                isFull: false,
                isAffix: false,
                isKeepAlive: true
              }
            }
          ]
        },
        {
          path: "/assignDevices/index",
          name: "assignDevices",
          component: "/assignDevices/index",
          meta: {
            title: "Assign devices",
            isHide: true,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/deviceLog/index",
          name: "DeviceLog",
          component: "/deviceLog/index",
          meta: {
            title: "Device logs",
            isHide: false,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/otaRecord/index",
          name: "OtaRecord",
          component: "/otaRecord/index",
          meta: {
            title: "Upgrade records",
            isHide: false,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/FirmwareManagement/index",
          name: "FirmwareManagement",
          component: "/firmwareManagement/index",
          meta: {
            title: "Firmware management",
            isHide: false,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/deviceType/index",
          name: "deviceType",
          component: "/deviceType/index",
          meta: {
            title: "Device Type",
            isHide: false,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          },
          children: [
            {
              path: "/deviceTypeOverview/index",
              name: "deviceTypeOverview",
              component: "/deviceTypeOverview/index",
              meta: {
                title: "overview",
                isLink: "",
                isHide: true,
                isFull: false,
                isAffix: true,
                isKeepAlive: true
              }
            },
            {
              path: "/deviceTypeAdd/index",
              name: "deviceTypeAdd",
              component: "/deviceTypeAdd/index",
              meta: {
                title: "Add new device type",
                isHide: true,
                isFull: false,
                isAffix: false,
                isKeepAlive: true
              }
            },
            {
              path: "/deviceTypeEdit/index",
              name: "deviceTypeEdit",
              component: "/deviceTypeEdit/index",
              meta: {
                title: "Edit device type",
                isHide: true,
                isFull: false,
                isAffix: false,
                isKeepAlive: true
              }
            }
          ]
        },

        {
          path: "/boarding/index",
          name: "boarding",
          component: "/boarding/index",
          meta: {
            title: "On/ Off boarding",
            isHide: true,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/activateDevices/index",
          name: "activateDevices",
          component: "/activateDevices/index",
          meta: {
            title: "Actived devices",
            isHide: true,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/firmwareAdd/index",
          name: "firmwareAdd",
          component: "/firmwareAdd/index",
          meta: {
            title: "Add Firmware",
            isHide: true,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        },
        {
          path: "/firmwareOverview/index",
          name: "firmwareOverview",
          component: "/firmwareOverview/index",
          meta: {
            title: "Firmware overview",
            activeMenu: "/FirmwareManagement/index",
            isHide: true,
            isFull: false,
            isAffix: false,
            isKeepAlive: true
          }
        }
      ]
    },
    {
      path: "/administration",
      name: "administration",
      component: "/administration/index",
      meta: {
        title: "Administration",
        isLink: "",
        isHide: false,
        isFull: false,
        isAffix: false,
        isKeepAlive: true
      },
      children: [
        {
          path: "/userCreate/index",
          name: "userCreate",
          component: "/userCreate/index",
          meta: {
            title: "create User",
            isLink: "",
            isHide: true,
            isFull: false,
            isAffix: true,
            isKeepAlive: true
          }
        },
        {
          path: "/userEdit/index",
          name: "userEdit",
          component: "/userEdit/index",
          meta: {
            title: "Edit User",
            isLink: "",
            isHide: true,
            isFull: false,
            isAffix: true,
            isKeepAlive: true
          }
        },
        {
          path: "/userOverview/index",
          name: "userOverview",
          component: "/userEdit/index",
          meta: {
            title: "userOverview",
            isLink: "",
            isHide: true,
            isFull: false,
            isAffix: true,
            isKeepAlive: true
          }
        },
        {
          path: "/tenantEdit/index",
          name: "tenantEdit",
          component: "/tenantEdit/index",
          meta: {
            title: "tenantEdit",
            isLink: "",
            isHide: true,
            isFull: false,
            isAffix: true,
            isKeepAlive: true
          }
        }
      ]
    },
    {
      path: "/containerEdit/index",
      name: "containerEdit",
      component: "/containerEdit/index",
      meta: {
        title: "containerEdit",
        isLink: "",
        isHide: true,
        isFull: false,
        isAffix: true,
        isKeepAlive: true
      }
    }
  ];
}
const withoutMonitoringMenu = (routes: any[]) => routes.filter(route => route?.name !== "monitoring");
export const CMenuList = withoutMonitoringMenu(generateDynamicRoutes());
